import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import media from './media'
/**
* @see \App\Http\Controllers\ClassifiedController::index
* @see app/Http/Controllers/ClassifiedController.php:385
* @route '/dashboard/classifieds'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/dashboard/classifieds',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ClassifiedController::index
* @see app/Http/Controllers/ClassifiedController.php:385
* @route '/dashboard/classifieds'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ClassifiedController::index
* @see app/Http/Controllers/ClassifiedController.php:385
* @route '/dashboard/classifieds'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::index
* @see app/Http/Controllers/ClassifiedController.php:385
* @route '/dashboard/classifieds'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ClassifiedController::index
* @see app/Http/Controllers/ClassifiedController.php:385
* @route '/dashboard/classifieds'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::index
* @see app/Http/Controllers/ClassifiedController.php:385
* @route '/dashboard/classifieds'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::index
* @see app/Http/Controllers/ClassifiedController.php:385
* @route '/dashboard/classifieds'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\ClassifiedController::create
* @see app/Http/Controllers/ClassifiedController.php:460
* @route '/dashboard/classifieds/new'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/dashboard/classifieds/new',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ClassifiedController::create
* @see app/Http/Controllers/ClassifiedController.php:460
* @route '/dashboard/classifieds/new'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ClassifiedController::create
* @see app/Http/Controllers/ClassifiedController.php:460
* @route '/dashboard/classifieds/new'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::create
* @see app/Http/Controllers/ClassifiedController.php:460
* @route '/dashboard/classifieds/new'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ClassifiedController::create
* @see app/Http/Controllers/ClassifiedController.php:460
* @route '/dashboard/classifieds/new'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::create
* @see app/Http/Controllers/ClassifiedController.php:460
* @route '/dashboard/classifieds/new'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::create
* @see app/Http/Controllers/ClassifiedController.php:460
* @route '/dashboard/classifieds/new'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\ClassifiedController::edit
* @see app/Http/Controllers/ClassifiedController.php:767
* @route '/dashboard/classifieds/{classified}/edit'
*/
export const edit = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/dashboard/classifieds/{classified}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ClassifiedController::edit
* @see app/Http/Controllers/ClassifiedController.php:767
* @route '/dashboard/classifieds/{classified}/edit'
*/
edit.url = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { classified: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { classified: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            classified: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: typeof args.classified === 'object'
        ? args.classified.id
        : args.classified,
    }

    return edit.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ClassifiedController::edit
* @see app/Http/Controllers/ClassifiedController.php:767
* @route '/dashboard/classifieds/{classified}/edit'
*/
edit.get = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::edit
* @see app/Http/Controllers/ClassifiedController.php:767
* @route '/dashboard/classifieds/{classified}/edit'
*/
edit.head = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ClassifiedController::edit
* @see app/Http/Controllers/ClassifiedController.php:767
* @route '/dashboard/classifieds/{classified}/edit'
*/
const editForm = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::edit
* @see app/Http/Controllers/ClassifiedController.php:767
* @route '/dashboard/classifieds/{classified}/edit'
*/
editForm.get = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::edit
* @see app/Http/Controllers/ClassifiedController.php:767
* @route '/dashboard/classifieds/{classified}/edit'
*/
editForm.head = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\ClassifiedController::update
* @see app/Http/Controllers/ClassifiedController.php:865
* @route '/dashboard/classifieds/{classified}'
*/
export const update = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/dashboard/classifieds/{classified}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\ClassifiedController::update
* @see app/Http/Controllers/ClassifiedController.php:865
* @route '/dashboard/classifieds/{classified}'
*/
update.url = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { classified: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { classified: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            classified: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: typeof args.classified === 'object'
        ? args.classified.id
        : args.classified,
    }

    return update.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ClassifiedController::update
* @see app/Http/Controllers/ClassifiedController.php:865
* @route '/dashboard/classifieds/{classified}'
*/
update.put = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\ClassifiedController::update
* @see app/Http/Controllers/ClassifiedController.php:865
* @route '/dashboard/classifieds/{classified}'
*/
const updateForm = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ClassifiedController::update
* @see app/Http/Controllers/ClassifiedController.php:865
* @route '/dashboard/classifieds/{classified}'
*/
updateForm.put = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\ClassifiedController::destroy
* @see app/Http/Controllers/ClassifiedController.php:875
* @route '/dashboard/classifieds/{classified}'
*/
export const destroy = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/dashboard/classifieds/{classified}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\ClassifiedController::destroy
* @see app/Http/Controllers/ClassifiedController.php:875
* @route '/dashboard/classifieds/{classified}'
*/
destroy.url = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { classified: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { classified: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            classified: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: typeof args.classified === 'object'
        ? args.classified.id
        : args.classified,
    }

    return destroy.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ClassifiedController::destroy
* @see app/Http/Controllers/ClassifiedController.php:875
* @route '/dashboard/classifieds/{classified}'
*/
destroy.delete = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\ClassifiedController::destroy
* @see app/Http/Controllers/ClassifiedController.php:875
* @route '/dashboard/classifieds/{classified}'
*/
const destroyForm = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ClassifiedController::destroy
* @see app/Http/Controllers/ClassifiedController.php:875
* @route '/dashboard/classifieds/{classified}'
*/
destroyForm.delete = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\ClassifiedController::setMainImage
* @see app/Http/Controllers/ClassifiedController.php:1011
* @route '/dashboard/classifieds/{classified}/set-main-image/{mediaId}'
*/
export const setMainImage = (args: { classified: string | number | { id: string | number }, mediaId: string | number } | [classified: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: setMainImage.url(args, options),
    method: 'post',
})

setMainImage.definition = {
    methods: ["post"],
    url: '/dashboard/classifieds/{classified}/set-main-image/{mediaId}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ClassifiedController::setMainImage
* @see app/Http/Controllers/ClassifiedController.php:1011
* @route '/dashboard/classifieds/{classified}/set-main-image/{mediaId}'
*/
setMainImage.url = (args: { classified: string | number | { id: string | number }, mediaId: string | number } | [classified: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            classified: args[0],
            mediaId: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: typeof args.classified === 'object'
        ? args.classified.id
        : args.classified,
        mediaId: args.mediaId,
    }

    return setMainImage.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace('{mediaId}', parsedArgs.mediaId.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ClassifiedController::setMainImage
* @see app/Http/Controllers/ClassifiedController.php:1011
* @route '/dashboard/classifieds/{classified}/set-main-image/{mediaId}'
*/
setMainImage.post = (args: { classified: string | number | { id: string | number }, mediaId: string | number } | [classified: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: setMainImage.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ClassifiedController::setMainImage
* @see app/Http/Controllers/ClassifiedController.php:1011
* @route '/dashboard/classifieds/{classified}/set-main-image/{mediaId}'
*/
const setMainImageForm = (args: { classified: string | number | { id: string | number }, mediaId: string | number } | [classified: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: setMainImage.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ClassifiedController::setMainImage
* @see app/Http/Controllers/ClassifiedController.php:1011
* @route '/dashboard/classifieds/{classified}/set-main-image/{mediaId}'
*/
setMainImageForm.post = (args: { classified: string | number | { id: string | number }, mediaId: string | number } | [classified: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: setMainImage.url(args, options),
    method: 'post',
})

setMainImage.form = setMainImageForm

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/classifieds/{classified}/status-data'
*/
export const statusData = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: statusData.url(args, options),
    method: 'get',
})

statusData.definition = {
    methods: ["get","head"],
    url: '/dashboard/classifieds/{classified}/status-data',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/classifieds/{classified}/status-data'
*/
statusData.url = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { classified: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { classified: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            classified: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: typeof args.classified === 'object'
        ? args.classified.id
        : args.classified,
    }

    return statusData.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/classifieds/{classified}/status-data'
*/
statusData.get = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: statusData.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/classifieds/{classified}/status-data'
*/
statusData.head = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: statusData.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/classifieds/{classified}/status-data'
*/
const statusDataForm = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: statusData.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/classifieds/{classified}/status-data'
*/
statusDataForm.get = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: statusData.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/classifieds/{classified}/status-data'
*/
statusDataForm.head = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: statusData.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

statusData.form = statusDataForm

/**
* @see \App\Http\Controllers\ClassifiedController::updateStatus
* @see app/Http/Controllers/ClassifiedController.php:1367
* @route '/dashboard/classifieds/{classified}/status'
*/
export const updateStatus = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: updateStatus.url(args, options),
    method: 'patch',
})

updateStatus.definition = {
    methods: ["patch"],
    url: '/dashboard/classifieds/{classified}/status',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\ClassifiedController::updateStatus
* @see app/Http/Controllers/ClassifiedController.php:1367
* @route '/dashboard/classifieds/{classified}/status'
*/
updateStatus.url = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { classified: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { classified: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            classified: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: typeof args.classified === 'object'
        ? args.classified.id
        : args.classified,
    }

    return updateStatus.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ClassifiedController::updateStatus
* @see app/Http/Controllers/ClassifiedController.php:1367
* @route '/dashboard/classifieds/{classified}/status'
*/
updateStatus.patch = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: updateStatus.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\ClassifiedController::updateStatus
* @see app/Http/Controllers/ClassifiedController.php:1367
* @route '/dashboard/classifieds/{classified}/status'
*/
const updateStatusForm = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updateStatus.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ClassifiedController::updateStatus
* @see app/Http/Controllers/ClassifiedController.php:1367
* @route '/dashboard/classifieds/{classified}/status'
*/
updateStatusForm.patch = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updateStatus.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

updateStatus.form = updateStatusForm

/**
* @see \App\Http\Controllers\ClassifiedController::statistics
* @see app/Http/Controllers/ClassifiedController.php:1309
* @route '/dashboard/classifieds/{classified}/statistics'
*/
export const statistics = (args: { classified: string | number } | [classified: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: statistics.url(args, options),
    method: 'get',
})

statistics.definition = {
    methods: ["get","head"],
    url: '/dashboard/classifieds/{classified}/statistics',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ClassifiedController::statistics
* @see app/Http/Controllers/ClassifiedController.php:1309
* @route '/dashboard/classifieds/{classified}/statistics'
*/
statistics.url = (args: { classified: string | number } | [classified: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { classified: args }
    }

    if (Array.isArray(args)) {
        args = {
            classified: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: args.classified,
    }

    return statistics.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ClassifiedController::statistics
* @see app/Http/Controllers/ClassifiedController.php:1309
* @route '/dashboard/classifieds/{classified}/statistics'
*/
statistics.get = (args: { classified: string | number } | [classified: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: statistics.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::statistics
* @see app/Http/Controllers/ClassifiedController.php:1309
* @route '/dashboard/classifieds/{classified}/statistics'
*/
statistics.head = (args: { classified: string | number } | [classified: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: statistics.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ClassifiedController::statistics
* @see app/Http/Controllers/ClassifiedController.php:1309
* @route '/dashboard/classifieds/{classified}/statistics'
*/
const statisticsForm = (args: { classified: string | number } | [classified: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: statistics.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::statistics
* @see app/Http/Controllers/ClassifiedController.php:1309
* @route '/dashboard/classifieds/{classified}/statistics'
*/
statisticsForm.get = (args: { classified: string | number } | [classified: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: statistics.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::statistics
* @see app/Http/Controllers/ClassifiedController.php:1309
* @route '/dashboard/classifieds/{classified}/statistics'
*/
statisticsForm.head = (args: { classified: string | number } | [classified: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: statistics.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

statistics.form = statisticsForm

const classifieds = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
    media: Object.assign(media, media),
    setMainImage: Object.assign(setMainImage, setMainImage),
    statusData: Object.assign(statusData, statusData),
    updateStatus: Object.assign(updateStatus, updateStatus),
    statistics: Object.assign(statistics, statistics),
}

export default classifieds